<!--  HIVATALI KAPUN BEÉRKEZETT KÜLDEMÉNYEK ÉS IGAZOLÁSOK – saját menüpont.
      Korábban a BKSZ-beállító aljára volt szorítva; a beállítást egyszer állítják be,
      ezt a listát viszont naponta nézik. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Beérkezett küldemények és igazolások</ion-card-title>
    <ion-card-subtitle>
      A hivatali kapu postafiókját a BKSZ gépi kapcsolatán töltjük le – nem az Ügyfélkapun. Minden tétel eredetiben
      eltárolódik: a küldeményekből érkeztetés lesz a fájllal együtt, az igazolások (feladási, letöltési,
      meghiúsulási) a kiküldött tételhez kerülnek, és a postakönyvben átvételkor „átvéve" lesz. A tétel csak a
      sikeres tárolás után törlődik a postafiókból.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="ikt-fejsor" style="align-items:flex-end; flex-wrap:wrap; gap:10px">
      <ion-searchbar class="ikt-kereso" placeholder="Érkeztetési szám, feladó, tárgy, fájlnév, iktatószám…"
                     [(ngModel)]="kereses" (ionInput)="keresesValtozott()" (ionClear)="keresesValtozott()"
                     [debounce]="0" mode="md"></ion-searchbar>
      <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="betoltFut">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
      </ion-button>
      <ion-button size="small" fill="outline" (click)="inditas()" [disabled]="bejovo.statusz?.fut">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>Letöltés most
      </ion-button>
      <ion-button size="small" fill="outline" color="danger" *ngIf="bejovo.statusz?.fut"
                  (click)="megszakitas()" [disabled]="bejovo.statusz?.megszakitas">
        <ion-icon slot="start" name="stop-circle-outline"></ion-icon>
        {{ bejovo.statusz?.megszakitas ? 'Megszakítás folyamatban…' : 'Megszakítás' }}
      </ion-button>
    </div>

    <!--  Az ütemezés itt van, nem a beállítóban: azt az ember kapcsolja, aki a letöltést figyeli. -->
    <div class="ikt-fejsor" style="align-items:flex-end; flex-wrap:wrap; gap:10px; margin-top:4px">
      <ion-toggle [(ngModel)]="bejovo.enabled" labelPlacement="end">Automatikus letöltés</ion-toggle>
      <ion-select label="Gyakoriság" label-placement="stacked" interface="popover" style="max-width:180px"
                  [(ngModel)]="bejovo.intervallum_perc">
        <ion-select-option *ngFor="let i of intervallumok" [value]="i.perc">{{ i.cim }}</ion-select-option>
      </ion-select>
      <ion-button size="small" (click)="mentes()" [disabled]="mentesFut">
        <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
      </ion-button>
      <ion-button size="small" fill="clear" routerLink="/iktatgato/bksz">Kapcsolat beállítása</ion-button>
    </div>

    <div *ngIf="bejovo.postafiok && !bejovo.postafiok.rovidnev" class="bksz-feltetel" style="margin-top:8px">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <span>A letöltéshez a <b>BKSZ kapcsolat</b> képernyőn meg kell adni a saját postafiók rövid nevét.</span>
    </div>

    <div *ngIf="bejovo.statusz?.fut" style="margin-top:10px">
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
      <small>{{ bejovo.statusz?.tipus === 'automatikus' ? 'Automatikus letöltés fut' : 'Letöltés fut' }} —
        {{ bejovo.statusz?.kor || 0 }}. kör, letöltve: {{ bejovo.statusz?.letoltve || 0 }},
        új: {{ bejovo.statusz?.uj || 0 }}, visszaigazolva: {{ bejovo.statusz?.visszaigazolva || 0 }}</small>
    </div>

    <p *ngIf="!bejovo.statusz?.fut && bejovo.utolso_futas" style="font-size:.82rem; margin:10px 0 4px">
      Utolsó futás: <b>{{ bejovo.utolso_futas | date:'yyyy-MM-dd HH:mm' }}</b> — {{ bejovo.utolso_eredmeny }}
    </p>
    <details *ngIf="bejovo.utolso_hibak?.length" style="font-size:.78rem; margin-bottom:8px">
      <summary>{{ bejovo.utolso_hibak.length }} hiba az utolsó futásban</summary>
      <div *ngFor="let h of bejovo.utolso_hibak">
        <span *ngIf="h.erkeztetesi_szam">{{ h.erkeztetesi_szam }}: </span>{{ h.hiba }}
      </div>
    </details>

    <ion-segment [(ngModel)]="szuro" (ionChange)="betolt()" mode="ios" style="max-width:420px; margin:8px 0">
      <ion-segment-button value="">Mind</ion-segment-button>
      <ion-segment-button value="kuldemeny">Küldemények</ion-segment-button>
      <ion-segment-button value="igazolas">Igazolások</ion-segment-button>
    </ion-segment>

    <div style="overflow-x:auto" *ngIf="lista.length; else nincsTetel">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th>Érkezett</th><th>Feladó</th><th>Tárgy / típus</th><th>Fájl</th>
            <th>Hová került</th><th>Postafiókból</th><th>Művelet</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of lista">
            <td>{{ t.erkezett | date:'yyyy-MM-dd HH:mm' }}<br><small>{{ t.erkeztetesi_szam }}</small></td>
            <td>{{ t.felado_nev || '–' }}<br><small>{{ feladoTipusNev(t.felado_tipus) }}</small></td>
            <td>
              <ng-container *ngIf="t.fajta === 'igazolas'">
                <ion-badge color="tertiary">igazolás</ion-badge> {{ t.igazolas_tipus }}
              </ng-container>
              <ng-container *ngIf="t.fajta !== 'igazolas'">{{ t.megjegyzes || t.doktipus_leiras || '–' }}</ng-container>
            </td>
            <td>
              <a href="javascript:void(0)" (click)="megnyit(t)">{{ t.fajl_nev || 'megnyitás' }}</a>
              <br><small>{{ (t.meret || 0) / 1024 | number:'1.0-0' }} KB</small>
            </td>
            <td>
              <span *ngIf="t.erkeztetes_id">
                érkeztetve: {{ t.erkeztetes_sorszam }}/{{ t.erkeztetes_ev }}
                <ion-badge color="success" *ngIf="t.erkeztetes_iktatva">iktatva</ion-badge>
              </span>
              <span *ngIf="t.fajta === 'igazolas' && t.postakonyv_id">
                <br *ngIf="t.erkeztetes_id">{{ t.igazolt_cimzett }} – {{ t.igazolt_statusz }}
                <small *ngIf="t.igazolt_iktatoszam"><br>{{ t.igazolt_iktatoszam }}</small>
              </span>
              <span *ngIf="t.fajta === 'igazolas' && !t.postakonyv_id" style="color:var(--ion-color-medium)">
                <br *ngIf="t.erkeztetes_id">nem párosítható kiküldéssel{{ t.igazolt_erkeztetesi_szam ? ' (' + t.igazolt_erkeztetesi_szam + ')' : '' }}
              </span>
              <span *ngIf="t.fajta !== 'igazolas' && !t.erkeztetes_id" style="color:var(--ion-color-medium)">nincs érkeztetve</span>
            </td>
            <td>
              <ion-badge *ngIf="t.visszaigazolva" color="success">törölve</ion-badge>
              <ion-badge *ngIf="!t.visszaigazolva" color="warning" [title]="t.visszaigazolas_hiba || ''">még ott van</ion-badge>
            </td>
            <td class="ikt-muvelet">
              <ion-button size="small" fill="outline" *ngIf="!t.erkeztetes_id"
                          (click)="erkeztet(t)" [disabled]="muveletFut === t.id">Érkeztetés</ion-button>
              <ion-button size="small" *ngIf="!t.erkeztetes_iktatva"
                          (click)="iktat(t)" [disabled]="muveletFut === t.id">Iktatás</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #nincsTetel>
      <p style="font-size:.85rem; color:var(--ion-color-medium)">
        {{ kereses ? 'Erre a keresésre nincs találat.' : 'Még nincs letöltött tétel.' }}
      </p>
    </ng-template>
  </ion-card-content>
</ion-card>
